/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface AffiliateTeamAllOfStaking
 */
export interface AffiliateTeamAllOfStaking {
  /**
   *
   * @type {number}
   * @memberof AffiliateTeamAllOfStaking
   */
  totalEarned?: number
  /**
   *
   * @type {number}
   * @memberof AffiliateTeamAllOfStaking
   */
  members?: number
}

export function AffiliateTeamAllOfStakingFromJSON(json: any): AffiliateTeamAllOfStaking {
  return AffiliateTeamAllOfStakingFromJSONTyped(json, false)
}

export function AffiliateTeamAllOfStakingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AffiliateTeamAllOfStaking {
  if (json === undefined || json === null) {
    return json
  }
  return {
    totalEarned: !exists(json, 'totalEarned') ? undefined : json['totalEarned'],
    members: !exists(json, 'members') ? undefined : json['members'],
  }
}

export function AffiliateTeamAllOfStakingToJSON(value?: AffiliateTeamAllOfStaking | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    totalEarned: value.totalEarned,
    members: value.members,
  }
}
